"use client"

import styled from "@emotion/styled"
import Container from "@eurodrive/ui/Container"
import { sharedColors } from "@eurodrive/ui/theme/colors"
import { IconButton, Typography } from "@mui/material"
import { SaleCarDto } from "api"
import Image from "next/image"
import { Swiper } from "swiper/react"
import { CarUmbraco } from "./extractUmbraco"
import SpinCarWidget from "./SpinCarWidget"

const StyledContainer = styled.div`
  padding-top: 56px;
  padding-bottom: 64px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 64px;
    grid-template-columns: 1fr 515px;
    gap: 108px;
  }
`

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
const InfoBox = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  border-radius: 16px;
  background: ${sharedColors.lightGrey};
`

const TopTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const StyledSwiper = styled(Swiper)`
  height: 348px;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 515px;
  }
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    width: 32px;
    height: 32px;
    padding: 10px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: #fff;

    &:after {
      display: none;
    }
  }
`

const NavigationArrow = styled(IconButton)`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 10px 0px;
  justify-content: center;
  align-items: center;
  border-radius: 4px !important;
  background: #fff;
  width: fit-content;
  &:hover {
    background: white;
  }
`
const NavigationButtons = styled.div`
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  z-index: 10;
`

const StyledTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "component",
})<{ component?: any }>`
  p {
    margin: 0;
  }
`
export default function TextImageBlock({
  data,
  carUmbraco,
  aboutText,
  zeroKmTitle,
  zeroKmContent,
}: {
  data: SaleCarDto
  carUmbraco?: CarUmbraco
  aboutText?: string
  zeroKmTitle?: string
  zeroKmContent?: string
}) {
  return (
    <Container paddingMobile>
      <StyledContainer>
        <ContentBox>
          <TextBox>
            <Typography variant="h2">
              {aboutText} {data.modelName}
            </Typography>
            {data.extendedMarketingDescription && (
              <StyledTypography
                variant="body2"
                component={"div"}
                dangerouslySetInnerHTML={{
                  __html: data.extendedMarketingDescription?.replace(
                    /<\/?p\b[^>]*>/gi,
                    "",
                  ),
                }}
              />
            )}
          </TextBox>

          <InfoBox>
            <TopTitle>
              <Image
                src="/icons/warning.svg"
                alt="car"
                width={24}
                height={24}
              />
              <StyledTypography variant="body2" fontWeight={600}>
                {zeroKmTitle}
              </StyledTypography>
            </TopTitle>
            {zeroKmContent?.length && (
              <StyledTypography
                variant="body2"
                component={"div"}
                dangerouslySetInnerHTML={{
                  __html: zeroKmContent?.replace(/<\/?p\b[^>]*>/gi, ""),
                }}
              />
            )}
          </InfoBox>
        </ContentBox>
        <SpinCarWidget spinCarId={data.detailedImages?.spinCarId} />
      </StyledContainer>
    </Container>
  )
}
